import React, { Component } from "react";
import { Layout, Icon, Tooltip, Spin } from "antd";
import { Parse } from "parse";
import { Line, Chart } from "react-chartjs-2";
import { Link } from "react-router-dom";
import { FormattedMessage, FormattedHTMLMessage,   injectIntl } from "react-intl";

import { getArraysBetweenTwoDates } from "../../utils/getDateInfo";
import { getReportData } from "../../utils/fetchDataFromDB";
import { processAnFetchData } from "../../utils/errorHandling";
import ClosePopUpCheckboxUI from "../../components/ClosePopUpCheckboxUI";
import getCookie from "../../cookie/getCookie";

import moment from "moment";
import "moment/locale/ko";

import ReportNav from "../../components/navigation/ReportNav";
import Headline from "../../components/Headline";

import "../../styles/Mypage.css";

require("../../utils/customizedChart.js");

const { Content } = Layout;
const DUMMY_DATA_COLOR = "#ddd";

const INDEX_DATA = {
  viewPoint: {
    label: {
      en: "View Index",
      ko: "노출지수",
    },
    color: "#3250fa",
  },
  sharePoint: {
    label: {
      en: "Share Index",
      ko: "사용지수",
    },
    color: "#2fd2a1",
  },
  activityPoint: {
    label: {
      en: "Activity Index",
      ko: "활동지수",
    },
    color: "#ff8500",
  },
};

let monthlyChartDataForm = {
  labels: [],
  datasets: [
    {
      key: "viewPoint",
      data: [],
      label: INDEX_DATA["viewPoint"].label.en,
      colors: [INDEX_DATA["viewPoint"].color],
      fill: false,
    },
    {
      key: "sharePoint",
      data: [],
      label: INDEX_DATA["sharePoint"].label.en,
      colors: [INDEX_DATA["sharePoint"].color],
      fill: false,
    },
    {
      key: "activityPoint",
      data: [],
      label: INDEX_DATA["activityPoint"].label.en,
      colors: [INDEX_DATA["activityPoint"].color],
      fill: false,
    },
  ],
};

const GUIDE_COOKIE_NAME = "dashboard-guide";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      guideVisible: getCookie(GUIDE_COOKIE_NAME) ? false : true,
      isExistReport: false,
      monthlyReportData: [],
      validLastReportData: {
        viewPoint: 0,
        sharePoint: 0,
        activityPoint: 0,
      },
      validLastDate: moment().format("YYYYMM"),
    };
  }
  componentWillMount() {
    Chart.pluginService.register({
      beforeDatasetsUpdate: (chart, easing) => {
        if (chart.config.type === "line") {
          // Plugin code.
          const ctx = chart.chart.ctx;
          const xAxis = chart.scales["x-axis-0"];
          chart.data.datasets.forEach((dataset) => {
            let gradientStroke = ctx.createLinearGradient(xAxis.left, 0, xAxis.right, 0);

            dataset.colors.forEach((c, i) => {
              const stop = i === 0 ? 0 : (1 / (dataset.colors.length - 1)) * i;
              gradientStroke.addColorStop(stop, c);
            });

            dataset.backgroundColor = gradientStroke;
            dataset.borderColor = gradientStroke;
            dataset.pointBorderColor = gradientStroke;
            dataset.pointBackgroundColor = gradientStroke;
            dataset.pointHoverBorderColor = gradientStroke;
            dataset.pointHoverBackgroundColor = gradientStroke;
          });
          
          const datalength = chart.data.datasets[0].data.length;
          
          //차트 너비 조절 및 block조정
          const backgroundStart = (chart.data.datasets[0].colors.indexOf(DUMMY_DATA_COLOR)) * (100 / datalength);

          //차트의 크기를 조절하는 부분
          chart.canvas.parentNode.style.width = `${datalength * 60}px`;;
          chart.canvas.style.background = `linear-gradient(90deg, transparent 0% ${backgroundStart}%, #f3f3f3 ${backgroundStart}% 100%)`;
        }
      },
    });
  }


  //DB로 부터 데이터를 받는 부분
  async componentDidMount() {
    const locale = this.props.intl.locale;
    let reportData = {};

    try {
      reportData = await getReportData(Parse.User.current());
    } catch (err) {
      if (err.message !== "Report does not exist.") {
        processAnFetchData(err);
      }
      this.setState({ loading: false });
      return;
    }

    // 그래프의 label 언어 변경
    monthlyChartDataForm.datasets.map((dataset) => (dataset.label = INDEX_DATA[dataset.key].label[locale]));

    //dateList : 12개로 된 월별 리스트 , validLastReportData : 마지막 달 3종류 데이터 
    const { dateList, validLastReportData, validLastDate } = reportData;

    //moment 언어 설정
    moment.locale(locale);

    //chart 데이터 삭제
    removeChartData();

    //chart 데이터 추가
    addChartData(dateList, reportData, locale);

    this.setState(
      {
        isExistReport: true,
        loading: false,
        validLastDate: validLastDate,
        validLastReportData: validLastReportData,
      },
      () => this.reference.chartInstance.update(),
    );
  }

  render() {
  
    const creatorNickName = Parse.User.current().get("nickname").en;
    const { locale } = this.props.intl;
    const GUIDE_PATH = locale === "ko" ? "222039647888" : "222039648491";
    const { validLastReportData, validLastDate, loading, isExistReport, guideVisible } = this.state;

    //차트 옵션
    const monthlyChartOption = {
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            ticks: {
              max : this.props.maxX
            },
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              display: false, //y축 라벨 데이터 숨기기
            },
            gridLines: {
              display: false, //배경 gridline 숨기기
            },
          },
        ],
      },
      hover: {
        intersect: false, //hover시 point 활성화를 위해
      },
      tooltips: {
        mode: "index",
        intersect: false,
        titleFontFamily: "NotoSans",
        titleFontSize: 14,
        titleFontStyle: "normal",
        bodyFontFamily: "NotoSans",
        bodyFontSize: 14,
        xPadding: 15,
        yPadding: 15,
        displayColors: false,
        yAlign: "bottom", // tooltip caret 항상 맨 아래로 표시
        backgroundColor: "rgba(64, 64, 64, 0.8)",
        filter: function(tooltipItem, data) {
          //실제 creatorReport데이터가 아닐 경우 툴팁 뜨지 않도록 수정
          const pointData = data.datasets[tooltipItem.datasetIndex];
          
          //처음으로 나오는 더미데이터 색상 찾기
          const dummyDataNum = pointData.colors.indexOf(DUMMY_DATA_COLOR);

          //더미데이터 보다 전이면 출력
          if (tooltipItem.index < dummyDataNum) {
            return true;
          }
        },
        // custom : (tooltip) => customTooltipFunc(tooltip, this.reference),
        callbacks: {
          
          title: () => null,
          label: (tooltipItem, data) => {
            //툴팁에 대한 조정
            const pointData = data.datasets[tooltipItem.datasetIndex];

            let pointText = pointData.label; //노출 ,사용, 활동 지수
            const dummyDataNum = pointData.colors.indexOf(DUMMY_DATA_COLOR);

            //더미데이터면 툴팁을 표시하지 않도록 하는 조건문
            if (tooltipItem.index >= dummyDataNum) {
              return null;
            }

            const leadingSpaces = (n, digits) => (n.length >= digits ? n : n + "\t".repeat(digits - n.length));

            if (locale === "en") {
              pointText = leadingSpaces(pointText.split(" ")[0], 10);
            } else {
              pointText = leadingSpaces(pointText, 6);
            }

            return pointText + tooltipItem.value;
          },
        },
      },
    };
    return (
      <Layout style={{ background: "#fff" }}>
        <ReportNav selectedKey="dashboard" />
        <Content style={{ margin: 20 }}>
          <Headline id="Report.dashboard.headline" defaultMessage="Dashboard" />
          <div className="content-margin">
            <div className="dashboard-title-wrapper">
              <div className="dashboard-title-greeting">
                <FormattedMessage id="Report.dashboard.title.hello" defaultMessage="Hello!" />
                <img src={require("../../img/creator-moji@2x.png").default} width={53} alt="hello-creator" />
                <FormattedHTMLMessage id="Report.dashboard.title.creator" defaultMessage="<p>Creator {creator}</p>" values={{ creator: creatorNickName }} />
              </div>
            </div>
            <div className="montly-report-title-wrapper">
              <p className="report-title">
                <FormattedMessage id="Report.dashboard.monthlyReport" defaultMessage="Monthly Report" />
              </p>
              <div className="dashboard-title-guide" onClick={() => this.setState({ guideVisible: !guideVisible })} style={{ visibility: guideVisible ? "hidden" : "inherit" }}>
                <Icon type="question-circle" style={{ width: 15, marginRight: 6 }} />
                <FormattedMessage id="Report.dashboard.guide.text" defaultMessage="Monthly Report Guide" />
              </div>
            </div>
            <Spin tip="loading..." spinning={loading} wrapperClassName="loading-style">
              <div className="monthly-report-chart-wrapper">
                <div className="monthly-report-legend-wrapper">
                  <div className="monthly-report-legend-box">
                    {Object.keys(INDEX_DATA).map((pointType) => (
                      <div className="monthly-report-legend" key={pointType}>
                        <div className="monthly-report-legend-color" style={{ background: INDEX_DATA[pointType].color }} />
                        {INDEX_DATA[pointType].label[locale]}
                      </div>
                    ))}
                  </div>
                  <p className="montly-report-title-guide">
                    <FormattedMessage id="Report.dashboard.monthlyReport.guide" defaultMessage="※Hover over the graph to see monthly View/Share/Activity indices." />
                  </p>
                </div>
                {!isExistReport && !loading ? (
                  <NoCRDataView nickname={creatorNickName} locale={locale} />
                ) : (
                  <div className="monthly-report-chart-box">
                    <Line data={monthlyChartDataForm} ref={(ref) => (this.reference = ref)} options={monthlyChartOption} />
                  </div>
                )}
              </div>
              <div className="point-viewer-wrapper">
                {Object.keys(INDEX_DATA).map((pointType) => (
                  <PointViewer
                    key={pointType}
                    point={{
                      type: pointType,
                      name: INDEX_DATA[pointType].label[locale],
                      value: validLastReportData[pointType],
                    }}
                    guideVisible={guideVisible}
                    color={INDEX_DATA[pointType].color}
                    month={isExistReport ? moment(validLastDate, "YYYYMM").format("MMMM") : null}
                  />
                ))}
              </div>
            </Spin>
            <Link to={{pathname:`https://blog.naver.com/mojitok/${GUIDE_PATH}`}} target="_blank">
              <img src={require(`../../img/cta/dashboard_${locale}@2x.png`).default} alt="cta-button" className="report-cta-btn" />
            </Link>
          </div>
        </Content>
        <div className={guideVisible ? "dashboard-guide-filter" : "disabled-dashboard-guide-filter"} />
        <div className={guideVisible ? "dashboard-guide-wrapper" : "disabled-dashboard-guide-wrapper"}>
          <div style={{ position: "relative", width: "100%" }}>
            <div className="dashboard-guide-img-wrapper" style={{ left: locale === "ko" ? 260 : 270 }}>
              <img src={require(`../../img/monthly_report_guide_${locale}@2x.png`).default} alt="dashboard-guide" className="dashboard-guide-img" />
            </div>

            <div className="dashboard-guide-close-wrapper">
              <ClosePopUpCheckboxUI
                isExistedCookie={getCookie(GUIDE_COOKIE_NAME) ? true : false}
                cookieName={GUIDE_COOKIE_NAME}
                cookieValue={true}
                expiredays={new Date("9999-12-31")}
                closeFunc={() => this.setState({ guideVisible: false })}
                style={{ color: "#fff" }}
              />
              <div className="dashboard-guide-close-btn" onClick={() => this.setState({ guideVisible: false })}>
                <Icon type="close" />
                <FormattedMessage id="ClosePopup.button.text" defaultMessage="Close" />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}
 
Dashboard = injectIntl(Dashboard);

const NoCRDataView = ({ nickname, locale }) => (
  <div className="monthly-report-chart-box monthly-report-no-data">
    <FormattedMessage id="Report.dashboard.noData.explain.title" defaultMessage="Thanks for joining Stickerfarm, {creator}!" values={{ creator: nickname }} />
    <FormattedHTMLMessage
      id="Report.dashboard.noData.explain.description"
      defaultMessage="Sorry, you don’t have sufficient activity on Stickerfarm to calculate Indexes yet.😢<br/>
      You may check records of your hard work at Stickerfarm with View/Share/Activity Indexes."
      values={{ creator: nickname }}
    />
    <FormattedMessage id="Report.dashboard.noData.explain.guide" defaultMessage="Your View/Share/Activity Indexes for each month will be released in the second week of the following month." />
  </div>
);

const PointViewer = ({ month, color, point, guideVisible }) => (
  <div className="point-viewer-box">
    {guideVisible ? null : (
      <div>
        <div className="point-viewer-title">
          <FormattedMessage id="Report.dashboard.pointViewer.title" defaultMessage="{point} in {month}" values={{ month: month, point: point.name }} />
          <Tooltip placement="top" title={<FormattedHTMLMessage id={`Report.dashboard.pointViewer.explain.${point.type}`} defaultMessage={point.type} />} overlayClassName="dashboard-tooltip-style">
            <div className="index-explain-icon">
              <Icon type="question-circle" style={{ color: color }} />
            </div>
          </Tooltip>
        </div>
        <div className="point-viewer-value">{point.value}</div>
      </div>
    )}
  </div>
);

const removeChartData = () => {
  //chart의 데이터 삭제
  monthlyChartDataForm.labels.splice(0, monthlyChartDataForm.labels.length);
  monthlyChartDataForm.datasets.map((dataset) => dataset.data.splice(0, dataset.data.length));
};

const addChartData = (yyyymmLabelList, dataObj, locale) => {

  const formatType = locale === "ko" ? "MMMM" : "MMM";

  //년도가 바뀔 때 연도 추가
  const mmLabelList = yyyymmLabelList.map((yyyymmLabel)=>{
    return moment(yyyymmLabel, 'YYYYMM').format('MM') === '01'
    ? [ moment(yyyymmLabel, 'YYYYMM').format(formatType), moment(yyyymmLabel, 'YYYYMM').format('YYYY')]
    : moment(yyyymmLabel, 'YYYYMM').format(formatType);
  });
  let dummyDateList = [];

  //마지막으로 데이터가 입력된 날짜 저장 
  const lastday = moment(yyyymmLabelList[yyyymmLabelList.length - 1],"YYYYMM");

  //현재 날짜와 마지막으로 기록된 날짜 사이 비교
  dummyDateList = getArraysBetweenTwoDates(
    lastday,
    new Date(),
    "month",  
  ); 
  
  dummyDateList.forEach((month) => mmLabelList.push(moment(month).format(formatType)));
  //label 시작 부분과 마지막 부분 연도 추가
  const firstDate = moment(yyyymmLabelList[0], 'YYYYMM');
  mmLabelList[0] = [firstDate.format(formatType),firstDate.format('YYYY')];
  mmLabelList.pop();
  mmLabelList.push([moment(lastday).add(dummyDateList.length,'months').format(formatType),
  moment(lastday).add(dummyDateList.length,'months').format('YYYY')]);

  //mmLableList Lable로써 저장
  monthlyChartDataForm.labels = mmLabelList;

  //value : (activity, shared, view)Point
  Object.keys(INDEX_DATA).forEach((value, idx) => {
    const dataLength = dataObj[value].length;
    const lastPoint = dataObj[value][dataLength - 1];
    const colors = Array(dataLength).fill(INDEX_DATA[value].color);
    dummyDateList.forEach((dummyDate) => {
      colors.push(DUMMY_DATA_COLOR);
      dataObj[value].push(lastPoint);
    });
    monthlyChartDataForm.datasets[idx] = {
      ...monthlyChartDataForm.datasets[idx],
      data: dataObj[value],
      colors: colors,
    };
  });
};

// const customTooltipFunc = (tooltip, ref) => {
//   // Create element on first render
//   var tooltipEl = document.getElementById('chartjs-tooltip');

//   if (!tooltipEl) {
//       tooltipEl = document.createElement('div');
//       tooltipEl.id = 'chartjs-tooltip';
//       tooltipEl.innerHTML = '<table></table>';
//       document.body.appendChild(tooltipEl);
//   }

//   // Hide if no tooltip
//   if (tooltip.opacity === 0) {
//     tooltipEl.style.opacity = 0;
//     return;
//   }

//   // Set caret Position
//   tooltipEl.classList.remove('above', 'below', 'no-transform');
//   if (tooltip.yAlign) {
//       tooltipEl.classList.add(tooltip.yAlign);
//   } else {
//       tooltipEl.classList.add('no-transform');
//   }

//   function getBody(bodyItem) {
//       return bodyItem.lines;
//   }

//   let innerHtml = '<tbody>';

//   if (!tooltip) {
//     return;
//   }

//   if (tooltip.body) {
//     tooltip.body.forEach((body, idx) => {
//       const parts = body.lines[0].split(':'); //['노출지수', '87.24']
//       innerHtml += `<tr><td><span>${parts[0]} <strong>${parts[1]}</strong></span></td></tr>`
//     })
//     innerHtml += '</tbody>';
//     var tableRoot = tooltipEl.querySelector('table');
//     tableRoot.innerHTML = innerHtml;
//   }

//   var position = ref.chartInstance.canvas.getBoundingClientRect();

//   // Display, position, and set styles for font
//   tooltipEl.style.opacity = 1;
//   tooltipEl.style.position = 'absolute';
//   tooltipEl.style.left = position.left + window.pageXOffset + tooltip.caretX + 'px';
//   tooltipEl.style.top = position.top + window.pageYOffset + tooltip.caretY + 'px';
//   tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
//   tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
//   tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
//   tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
//   tooltipEl.style.pointerEvents = 'none';
// };

export default Dashboard;
